/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 11:41:30
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-19 13:19:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/MockupImage/index.tsx
 */
import React from 'react';

import css from './css.module.less';

// import _ from 'lodash';

import { useDispatch } from 'react-redux';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getMockupImage,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onMockupImageImgOnChange,
  onMockupImageOnAdd,
  onMockupImageOnChange,
  onMockupImageOnDelete,
  onMockupImageOnSort,
} from '../slice';

import { Input, Switch } from '@/src/components/Antd';

import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import ImgDraggableDisplay from 'src/components/ImageDraggableDisplay';
import AutoPlay from 'src/constrains/SalesChannelPreviewPageComponents/AutoPlay';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import NonPrimaryTip from 'src/pages/SalesChannelContentEditor/Components/DisabledSectionTip';
import { generateImage } from 'src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/common';
import { validateMockupImages } from 'src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/tools';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';

const MockupImage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, specificError, isPrimary, disabled, hideEdit } = props;

  const {} = specificError;

  const _d = useDispatch();

  const {
    enabled,
    caption,
    autoPlay,
    intervalTime,
    linkModules = [],
  } = data || {};

  const _linkModules = linkModules.map((i) => {
    const { draggableId } = i;
    const imgErr = (specificError[`${draggableId}ImageError`] || []).join(' ');
    return { ...i, imgErr };

    //  const relatedKeys= Object.keys(specificError).filter((i) => i.startsWith(draggableId));
    //   if(relatedKeys.length>0){
    //     const err = specificError[`${draggableId}ImageError`];
    //   }
  });
  const handleOnStatusChange = (enabled) => {
    _d(onMockupImageOnChange({ data: { enabled } }));
  };

  const handleOnCaptionChange = (caption) => {
    _d(onMockupImageOnChange({ data: { caption } }));
  };

  const handleAutoPlayOnChange = (autoPlay) => {
    _d(onMockupImageOnChange({ data: { autoPlay } }));
  };

  const handleIntervalOnChange = (intervalTime) => {
    _d(onMockupImageOnChange({ data: { intervalTime } }));
  };

  const handleOnImageAdd = () => {
    _d(onMockupImageOnAdd(generateImage()));
  };

  const handleOnImageChange = (index, data) => {
    _d(onMockupImageImgOnChange({ index, data }));
  };

  const handleOnImageDelete = (index) => {
    _d(onMockupImageOnDelete(index));
  };

  const handleOnImageSort = (from, to) => {
    _d(onMockupImageOnSort({ from, to }));
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        {isPrimary && (
          <div className={css.enabledContainer}>
            <div className={css.enabledText}>
              {getI18n('general.hOCTitle.mockupImage')}
            </div>
            <Switch
              onChange={handleOnStatusChange}
              checked={enabled}
              disabled={disabled}
            />
          </div>
        )}
        {!isPrimary && !enabled && (
          <div className={css.nonPrimaryTip}>
            <NonPrimaryTip
              tip={getI18n(
                'salesChannelProductCustomization.index.turnonmockupimage',
              )}
            />
          </div>
        )}
      </Section>
      {enabled && (
        <React.Fragment>
          {' '}
          <Section bottomBorder>
            <ItemWrapper
              rightPart={
                <CountWords count={(caption || '').length} allCount={30} />
              }
              title={`${getI18n(
                'salesChannelProductCustomization.index.caption',
              )} (${getI18n('general.optional')})`}>
              <Input
                // error={captionError.length > 0}
                // help={captionError.join(' ')}
                value={caption}
                maxLength={30}
                onChange={handleOnCaptionChange}
                size='large'
                placeholder={`e.g. ${getI18n('general.hOCTitle.mockupImage')}`}
                disabled={disabled}
              />
            </ItemWrapper>
          </Section>
          <Section bottomBorder>
            <ItemWrapper
              title={getI18n(
                'salesChannelProductCustomization.index.imageCarousel',
              )}>
              <AutoPlay
                interOnChange={handleIntervalOnChange}
                autoOnChange={handleAutoPlayOnChange}
                isAuto={autoPlay}
                interval={intervalTime}
                disabled={disabled}
              />
            </ItemWrapper>
          </Section>
          <ImgDraggableDisplay
            // specificErr={specificError}
            data={_linkModules}
            droppableId={'SalesChannelLinkProductsCustomizationMockupImages'}
            addText={`+ ${getI18n('general.addImage')}`}
            onAdd={handleOnImageAdd}
            onChange={handleOnImageChange}
            onDelete={handleOnImageDelete}
            onSort={handleOnImageSort}
            disabled={disabled}
            hideEdit={hideEdit}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(MockupImage, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.mockupImage,
  getContent: getMockupImage,
  title: getI18nFromGeneral('general.hOCTitle.mockupImage'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateMockupImages(x, !isPrimary);
  },
  getSubmitStamp,
});
